import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import RootAppLayout from "../layout/RootAppLayout";
import Loader from "./Loader";
import ImageWithRetry from "./ImageWithRetry";

/**
 * Full page loading screen for the initial page loading states.
 * Note: there is a hard-coded HTML version of this in /index.html
 */
const LoaderFullPage = ({
  message = "",
  messages = null,
  intervalMs = 5000,
}) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!messages || messages.length < 2) return;
    const id = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [messages, intervalMs]);

  const displayMessage = messages?.length ? messages[messageIndex] : message;

  return (
    <RootAppLayout>
      <Loader mode="white" variant="dots" />
      <ImageWithRetry
        src="/signol-logo-white.svg"
        width="122"
        height="45"
        alt=""
      />
      <p className="text-primary-900 min-h-[1.5em]">{displayMessage}</p>
    </RootAppLayout>
  );
};

export const loaderFullPageControls = {
  message: {
    propType: PropTypes.string,
    controlType: "text",
  },
  messages: {
    propType: PropTypes.arrayOf(PropTypes.string),
    description:
      "Cycles through these messages (every intervalMs) instead of showing a static message",
    disable: true,
  },
  intervalMs: {
    propType: PropTypes.number,
    description: "Milliseconds each message in `messages` is shown for",
    controlType: "number",
    defaultValue: 5000,
  },
};

LoaderFullPage.propTypes = AppUtils.getPropTypeFromControls(
  loaderFullPageControls,
);

export default LoaderFullPage;
